/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CallbackFailure } from './CallbackFailure';
import {
    CallbackFailureFromJSON,
    CallbackFailureFromJSONTyped,
    CallbackFailureToJSON,
    CallbackFailureToJSONTyped,
} from './CallbackFailure';

/**
 * 
 * @export
 * @interface CallbackFailures
 */
export interface CallbackFailures {
    /**
     * 
     * @type {Array<CallbackFailure>}
     * @memberof CallbackFailures
     */
    failures: Array<CallbackFailure>;
    /**
     * 
     * @type {string}
     * @memberof CallbackFailures
     */
    nextCursor?: string;
}

/**
 * Check if a given object implements the CallbackFailures interface.
 */
export function instanceOfCallbackFailures(value: object): value is CallbackFailures {
    if (!('failures' in value) || value['failures'] === undefined) return false;
    return true;
}

export function CallbackFailuresFromJSON(json: any): CallbackFailures {
    return CallbackFailuresFromJSONTyped(json, false);
}

export function CallbackFailuresFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallbackFailures {
    if (json == null) {
        return json;
    }
    return {
        
        'failures': ((json['failures'] as Array<any>).map(CallbackFailureFromJSON)),
        'nextCursor': json['next_cursor'] == null ? undefined : json['next_cursor'],
    };
}

export function CallbackFailuresToJSON(json: any): CallbackFailures {
    return CallbackFailuresToJSONTyped(json, false);
}

export function CallbackFailuresToJSONTyped(value?: CallbackFailures | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'failures': ((value['failures'] as Array<any>).map(CallbackFailureToJSON)),
        'next_cursor': value['nextCursor'],
    };
}

